import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { transparentize } from 'polished';

import Link from '@material-ui/core/Link';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Typography from '@material-ui/core/Typography';

function DefaultRolesInfoCard() {
  const classes = useStyles();

  const defaultRoleBullets = [
    <>
      All <strong>Users</strong> will have access to view everyone else, but only can edit their own
      profile.
    </>,
    <>
      <strong>Managers</strong> will have access to view{' '}
      <Link
        href="http://help.justsift.com/en/articles/12530506-about-restricted-attributes"
        color="secondary"
        target="_blank"
        rel="noreferrer"
      >
        restricted attributes{' '}
      </Link>
      and edit profiles for everyone who directly or indirectly reports to them.
    </>,
  ];

  return (
    <div className={classes.root}>
      <div>
        <InfoOutlinedIcon className={classes.icon} />
      </div>
      <div>
        <Typography variant="h5" className={classes.cardTitle}>
          Read Me First: Default Roles and Permissions
        </Typography>

        <Typography>
          Sift provides a base set of roles and permissions that should work for many use cases. You
          may not need to change anything if these default roles work for you. In short:
        </Typography>
        <ul className={classes.list}>
          {defaultRoleBullets.map((bullet, index) => (
            <li key={index} className={classes.listItem}>
              <Typography>{bullet}</Typography>
            </li>
          ))}
        </ul>

        <Typography>
          If you need to modify these permissions, or grant additional permissions to certain people
          or groups, you may need to modify the roles below or create new roles.{' '}
          <Link
            href="http://help.justsift.com/en/articles/12526057-assigning-roles-and-permissions"
            color="secondary"
            target="_blank"
            rel="noreferrer"
          >
            Learn more about roles and permissions.
          </Link>
        </Typography>
      </div>
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    border: `1px solid ${transparentize(0.88, theme.palette.secondary.main)}`,
    backgroundColor: transparentize(0.96, theme.palette.secondary.main),
    padding: theme.spacing(2),
    borderRadius: theme.spacing(0.5),
    marginBottom: theme.spacing(2),
  },
  cardTitle: {
    marginBottom: theme.spacing(4),
  },
  icon: {
    height: 24,
    width: 24,
    marginTop: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(3),
  },
  list: {
    paddingLeft: theme.spacing(3),
  },
  listItem: {
    listStyleType: 'disc !important',
  },
}));

export default DefaultRolesInfoCard;
